import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, tap } from 'rxjs/operators';
import { HelpTopicQueryService } from './help-topic-query.service';
import {
  LoadOne,
  LoadOneFailure,
  LoadOneSuccess,
} from './help-topic.actions';
import { HelpTopic } from './help-topic.model';

export class HelpTopicStateModel {
  entity: HelpTopic;
  isLoading = false;
}

@State<HelpTopicStateModel>({
  name: 'helpTopics',
  defaults: new HelpTopicStateModel()
})
@Injectable()
export class HelpTopicState {
  constructor(
    private queryService: HelpTopicQueryService,
    private translate: TranslateService
  ) {}

  @Selector()
  static helpTopic(state: HelpTopicStateModel): HelpTopic {
    return state.entity;
  }

  @Selector()
  static isLoading(state: HelpTopicStateModel): boolean {
    return state.isLoading;
  }

  @Action(LoadOne)
  onLoadOne(
    { patchState, dispatch }: StateContext<HelpTopicStateModel>,
    { domain, key }: LoadOne
  ) {
    patchState({ isLoading: true });
    return this.queryService.get(domain, key).pipe(
      tap((res) => dispatch(new LoadOneSuccess(res))),
      catchError((error) => dispatch(new LoadOneFailure(error)))
    );
  }

  @Action(LoadOneSuccess)
  onLoadManySuccess(
    { patchState }: StateContext<HelpTopicStateModel>,
    { data }: LoadOneSuccess
  ) {
    patchState({ entity: data, isLoading: false });
  }

  @Action(LoadOneFailure)
  onLoadOneFailure({ patchState }: StateContext<HelpTopicStateModel>, _: LoadOneFailure) {
    patchState({ entity: null, isLoading: false });
  } 
}
